import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  CustomInput,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row } from 'reactstrap';

class DTCLoanOffer extends Component {
  state = {
    disabled: true,
    modalDisabled: true,
    modal: false,
    termsAgree: false
  }

  handleValueChange = () => {
    this.setState({ disabled: false })
  }

  handleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  handleTermsCheck = () => {
    this.setState({termsAgree: !this.state.termsAgree});
  }

  handleSignature = (evt) => {
    if (evt.target.value.length && this.state.termsAgree) {
      this.setState({
        modalDisabled: false,
      });
    } else {
      this.setState({
        modalDisabled: true
      });
    }
  }

  render() {
    const { modal } = this.state;

    return (
      <div className="page-loanoffer">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} xl={8}>
              <Row>
                <Col className="mb-2 mb-md-4 mt-1 mt-md-3">
                  <h1>Select Loan Offer</h1>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col xs={12}>
                  <h3 className="border-bottom pb-2 mb-3"><span className="flag-merchant">Merchant</span>&nbsp; Confirm Amount of Sale</h3>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <Label for="approvalAmount">Pre-Approval Amount</Label>
                    <Input type="text" name="approval-amount" id="approvalAmount" defaultValue="$2,500.00" onChange={this.handleValueChange} />
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <Label for="total">Confirm Service or Product Total</Label>
                    <Input type="text" name="total" id="total" defaultValue="$2,500.00" onChange={this.handleValueChange} />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <Button size="lg" color="primary" className="pl-0 pr-0 w-100" disabled={this.state.disabled}>Update</Button>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col xs={12}>
                  <h3 className="border-bottom pb-2 mb-3">Select an Offer</h3>
                </Col>

                <Col xs={12} md={6}>
                  <Card style={{ backgroundColor: '#d7e7f9' }}>
                    <CardHeader>
                      <h5 className="mb-0">36 Months</h5>
                    </CardHeader>
                    <Container fluid className="p-0">
                      <Row noGutters>
                        <Col xs={12} className="bg-white pt-3 pl-3 pr-3 text-center" style={{ zIndex: 1, position: 'relative' }}>
                          <h3 className="mb-2 text-success" style={{ fontWeight: 700 }}>0% APR for 6 Months*</h3>
                          <h5>Est. Monthly Payment</h5>
                          <h1 className="mb-0 text-primary">$103.79</h1>
                          <small className="text-muted"><strong>SAVE UP TO $260</strong></small>
                          <Button color="primary" className="w-100 mt-2" onClick={this.handleModal}>Select</Button>
                        </Col>
                        <Col xs={12} className="bg-white">
                          <Container className="p-3" fluid>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}>
                                <h5 className="mb-0">Amount Financed</h5>
                                <small>Includes the Origination Fee</small>
                              </Col>
                              <Col xs={4}><strong>$2,500.00</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">Loan Term</h5></Col>
                              <Col xs={4}><strong>36 Months</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">Interest Rate</h5></Col>
                              <Col xs={4}><strong>11.99%</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">APR</h5></Col>
                              <Col xs={4}><strong>24.99%</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}>
                                <h5 className="mb-0">Origination Fee</h5>
                                <small>Included in monthly payment</small>
                              </Col>
                              <Col xs={4}><strong>8%</strong></Col>
                            </Row>
                            <Row>
                              <Col><small className="text-secondary">Offer #220190</small></Col>
                            </Row>
                          </Container>
                        </Col>
                      </Row>
                    </Container>
                  </Card>
                </Col>

                <Col xs={12} md={6}>
                  <Card style={{ backgroundColor: '#d7e7f9' }}>
                    <CardHeader>
                      <h5 className="mb-0">60 Months</h5>
                    </CardHeader>
                    <Container fluid className="p-0">
                      <Row noGutters>
                        <Col xs={12} className="bg-white pt-3 pl-3 pr-3 text-center" style={{ zIndex: 1, position: 'relative' }}>
                          <h3 className="mb-2 text-success" style={{ fontWeight: 700 }}>0% APR for 6 Months*</h3>
                          <h5>Est. Monthly Payment</h5>
                          <h1 className="mb-0 text-primary">$80.86</h1>
                          <small className="text-muted"><strong>SAVE UP TO $260</strong></small>
                          <Button color="primary" className="w-100 mt-3" onClick={this.handleModal}>Select</Button>
                        </Col>
                        <Col xs={12} className="bg-white">
                          <Container className="p-3" fluid>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}>
                                <h5 className="mb-0">Amount Financed</h5>
                                <small>Includes the Origination Fee</small>
                              </Col>
                              <Col xs={4}><strong>$2,500.00</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">Loan Term</h5></Col>
                              <Col xs={4}><strong>60 Months</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">Interest Rate</h5></Col>
                              <Col xs={4}><strong>11.99%</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">APR</h5></Col>
                              <Col xs={4}><strong>24.99%</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}>
                                <h5 className="mb-0">Origination Fee</h5>
                                <small>Included in monthly payment</small>
                              </Col>
                              <Col xs={4}><strong>8%</strong></Col>
                            </Row>
                            <Row>
                              <Col><small className="text-secondary">Offer #220190</small></Col>
                            </Row>
                          </Container>
                        </Col>
                      </Row>
                    </Container>
                  </Card>
                </Col>
                <Col xs={12} md={6}>
                  <Card style={{ backgroundColor: '#d7e7f9' }}>
                    <CardHeader>
                      <h5 className="mb-0">36 Months</h5>
                    </CardHeader>
                    <Container fluid className="p-0">
                      <Row noGutters>
                        <Col xs={12} className="bg-white pt-3 pl-3 pr-3 text-center" style={{ zIndex: 1, position: 'relative' }}>
                          <h3 className="mb-2 text-success" style={{ fontWeight: 700 }}>0% APR for 12 Months*</h3>
                          <h5>Est. Monthly Payment</h5>
                          <h1 className="mb-0 text-primary">$103.79</h1>
                          <small className="text-muted"><strong>SAVE UP TO $324</strong></small>
                          <Button color="primary" className="w-100 mt-2" onClick={this.handleModal}>Select</Button>
                        </Col>
                        <Col xs={12} className="bg-white">
                          <Container className="p-3" fluid>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}>
                                <h5 className="mb-0">Amount Financed</h5>
                                <small>Includes the Origination Fee</small>
                              </Col>
                              <Col xs={4}><strong>$2,500.00</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">Loan Term</h5></Col>
                              <Col xs={4}><strong>60 Months</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">Interest Rate</h5></Col>
                              <Col xs={4}><strong>11.99%</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">APR</h5></Col>
                              <Col xs={4}><strong>24.99%</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}>
                                <h5 className="mb-0">Origination Fee</h5>
                                <small>Included in monthly payment</small>
                              </Col>
                              <Col xs={4}><strong>8%</strong></Col>
                            </Row>
                            <Row>
                              <Col><small className="text-secondary">Offer #220190</small></Col>
                            </Row>
                          </Container>
                        </Col>
                      </Row>
                    </Container>
                  </Card>
                </Col>

                <Col xs={12} md={6}>
                  <Card style={{ backgroundColor: '#d7e7f9' }}>
                    <CardHeader>
                      <h5 className="mb-0">60 Months</h5>
                    </CardHeader>
                    <Container fluid className="p-0">
                      <Row noGutters>
                        <Col xs={12} className="bg-white pt-3 pl-3 pr-3 text-center" style={{ zIndex: 1, position: 'relative' }}>
                          <h3 className="mb-2 text-success" style={{ fontWeight: 700 }}>0% APR for 12 Months*</h3>
                          <h5>Est. Monthly Payment</h5>
                          <h1 className="mb-0 text-primary">$80.86</h1>
                          <small className="text-muted"><strong>SAVE UP TO $324</strong></small>
                          <Button color="primary" className="w-100 mt-2" onClick={this.handleModal}>Select</Button>
                        </Col>
                        <Col xs={12} className="bg-white">
                          <Container className="p-3" fluid>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}>
                                <h5 className="mb-0">Amount Financed</h5>
                                <small>Includes the Origination Fee</small>
                              </Col>
                              <Col xs={4}><strong>$2,500.00</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">Loan Term</h5></Col>
                              <Col xs={4}><strong>60 Months</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">Interest Rate</h5></Col>
                              <Col xs={4}><strong>11.99%</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}><h5 className="mb-0">APR</h5></Col>
                              <Col xs={4}><strong>24.99%</strong></Col>
                            </Row>
                            <Row className="mb-1" noGutters>
                              <Col xs={8}>
                                <h5 className="mb-0">Origination Fee</h5>
                                <small>Included in monthly payment</small>
                              </Col>
                              <Col xs={4}><strong>8%</strong></Col>
                            </Row>
                            <Row>
                              <Col><small className="text-secondary">Offer #220190</small></Col>
                            </Row>
                          </Container>
                        </Col>
                      </Row>
                    </Container>
                  </Card>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <p><small className="text-muted"><strong>*No Interest on Principal Option Promotion.</strong> Your loan has a 6-month no interest on principal promotion included. This promotion can save you money as referenced in the “SPECIAL OFFER” section above provided you pay off the principal amount of the loan in full within the first 6 months. During the 6-month promotional period you will be responsible for making all of your monthly payments and your loan will accrue interest on a monthly basis. If you pay off your loan within the promotional period, the monthly payments that you have made during this period, which includes accrued interest, will be deducted from the principal amount of the loan. The principal amount includes the non-refundable 8% Loan Origination Fee. Please review your Loan Agreement for terms and conditions.  </small></p>
                  <p><small className="text-muted">**The APR represents the annual rate charged for borrowing these funds, it is comprised of the Interest Rate and an 8% Loan Origination Fee. The Loan Origination Fee is considered earned upon the funding of your loan and is non-refundable. The Loan Origination Fee is also provided to you in the ‘Itemization of Amount Financed’ section of your Loan Agreement.</small></p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        <Modal isOpen={modal} toggle={this.handleModal} size="lg">
          <ModalHeader toggle={this.handleModal}><span className="flag-merchant">Merchant</span>&nbsp; Please Confirm the Following</ModalHeader>
          <ModalBody>
            <Row className="mb-1">
              <Col sm={6} lg={4}>
                <FormGroup>
                  <Label for="amountFinanced">Amount Financed</Label>
                  <Input type="text" name="amount-financed" id="amountFinanced" defaultValue="$2,500.00" />
                </FormGroup>
              </Col>
              <Col sm={6} lg={4}>
                <FormGroup>
                  <Label for="payoutAmount">Payout Amount</Label>
                  <Input type="text" name="payout-amount" id="payoutAmount" defaultValue="$2,375.50" readOnly />
                </FormGroup>
              </Col>
              <Col sm={6} lg={4}>
                <FormGroup className="mb-2">
                  <Label for="purchaseDate">Purchase/Service Date</Label>
                  <Input type="date" name="purchase-date" id="purchaseDate" />
                </FormGroup>
              </Col>
              <Col xs={12}>
                <FormGroup>
                  <CustomInput
                    type="checkbox"
                    id="agree1"
                    label="I certify that the amount taken only includes services or products to be rendered. No origination fees or any other finance fees have been added. Non compliances will result in all funds being charged back and loan cancellation. Additionally, it is understood that I am not to attempt to collect additional fees directly from the customer in order to make up for the discount fees that I am incurring."
                  />
                </FormGroup>
                <FormGroup className="mb-3">
                  <CustomInput
                    onChange={this.handleTermsCheck}
                    type="checkbox"
                    id="agree2"
                    className="mb-1"
                    label="I certify that I have identified the borrower with a valid government issued ID and have retained a copy for my records which will be provided to LendingUSA, on behalf of Personify Financial, upon request."
                  />
                </FormGroup>
                <FormGroup className="mb-3">
                  <Label for="signature">Authorized Representative Signature</Label>
                  <Input
                    type="text"
                    name="signature"
                    id="signature"
                    onChange={this.handleSignature}
                  />
                </FormGroup>
              </Col>
              <Col lg={{size: 4, offset: 4}}>
                <Button
                  color="primary"
                  size="lg"
                  tag={Link}
                  to="/dtc/autopay"
                  id="SubmitLoanSelection"
                  className="w-100"
                  disabled={this.state.modalDisabled}
                  onClick={this.handleSubmit}>
                  Finalize Sale
                </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default DTCLoanOffer;
